import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import Store from '../../../Store/Store';
import { WOS_BASIC_01_Schema } from './M_WOS_BASIC_01_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../Hooks/apis/useQuriesSuccess';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

const toDataResponseFromResult = (res) => {
  const list = res?.Data ?? res?.data ?? (Array.isArray(res) ? res : []);
  return { data: Array.isArray(list) ? list : [] };
};

/** 사업장 조회 GetWosBasic01R1 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_01_Schema.mapper.search1,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasic01R1,
      params
    );
    return toDataResponseFromResult(res);
  }, successOptions);
};

/** 부서 조회 GetWosBasic01R2 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_01_Schema.mapper.search2,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasic01R2,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 부서 인원 조회 GetWosBasic01R3 */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_01_Schema.mapper.search3,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasic01R3,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 동일부서 결재권자 + 동일사업장 안전관리자 조회 (SaveLogic3용) GetWosBasic01R4 */
export const useSearch4 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      WOS_BASIC_01_Schema.mapper.search4,
      context
    );
    const res = await apiRequest(
      'post',
      Global.urls.WorkStop.getWosBasic01R4,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

export const useSearch5 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(WOS_BASIC_01_Schema.mapper.search5);

  const query = useQuery({
    queryKey: ['Depart', 'getDepBasicR1', params],
    queryFn: () => apiRequest('post', Global.urls.Depart.getDepBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 작업중지 등록 저장 SaveWosBasicU1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      WOS_BASIC_01_Schema.mapper.save1,
      context
    );
    return apiRequest('post1', Global.urls.WorkStop.saveWosBasic01U1, payload);
  }, options);
};

/** 작업중지 멤버 저장 SaveWosBasicU3 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(
      WOS_BASIC_01_Schema.mapper.save2,
      context
    );
    return apiRequest('post1', Global.urls.WorkStop.saveWosBasic01U2, payload);
  }, options);
};
